<div class="ts-cal">

    <!-- Month navigation header -->
    <div class="ts-cal__nav">
        <button class="ts-cal__nav-btn ts-cal__nav-btn--prev" type="button" (click)="prevMonth()">
            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M10 12L6 8l4-4"/>
            </svg>
        </button>
        <span class="ts-cal__month-label">{{ viewDate | date:'MMMM yyyy' }}</span>
        <button class="ts-cal__nav-btn ts-cal__nav-btn--next" type="button" (click)="nextMonth()">
            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M6 4l4 4-4 4"/>
            </svg>
        </button>
    </div>

    <!-- Day-name header row -->
    <div class="ts-cal__head">
        <div class="ts-cal__day-name" *ngFor="let d of dayNames">{{ d }}</div>
    </div>

    <!-- Calendar body -->
    <div class="ts-cal__body">
        <div class="ts-cal__cell"
             *ngFor="let cell of cells; trackBy: trackByDate"
             [class.ts-cal__cell--other]="!cell.inMonth"
             [class.ts-cal__cell--today]="cell.isToday"
             [class.ts-cal__cell--weekend]="cell.isWeekend"
             [class.ts-cal__cell--inrange]="cell.inMonth && !!cellDateKey(cell.date)">

            <span class="ts-cal__day-num" [class.ts-cal__day-num--weekend]="cell.isWeekend">
                {{ cell.day }}
            </span>

            <app-time-view
                *ngIf="cell.inMonth && cellDateKey(cell.date)"
                [editMode]="readOnly || isFutureCell(cell.date)"
                [enteredData]="hoursFor(cell.date)"
                [enteredComments]="commentsFor(cell.date)"
                [inputDate]="cellDateKey(cell.date)"
                (dateTimeEntered)="onDayChanged($event)">
            </app-time-view>

        </div>
    </div>

</div>
